/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
//import { Link } from "react-router-dom";
import { useState } from "react";
import Espacio from "./Espacio";
import Tipo from "./Tipo";
import Direccion from "./Direccion";
import DatosBasicos from "./Datos";
import Servicios from "./Servicios";
import Horarios from "./Horarios";
import Imagenes from "./Imagenes";
import Descripciones from "./Descripciones";
import Precio from "./Precio";
//import Descuentos from "./Descuentos";
import Tarifas from "./Tarifas";
import { FORMs } from "../../../../conts/Property";
import { useNavigate, useParams } from "react-router-dom";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";
import { useQuery } from "@tanstack/react-query";
import { CustomToast } from "../../../../utils/custom-toast";
import Bloqued from "./Bloqued";
import { Skeleton } from "../../../../components/UI/Skeleton";

const EditarAlquiler = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>(FORMs.PROPERTY);

  const onClick = async (e: any, property: any) => {
    switch (e.target.name) {
      case "save":
        {
          let formdata = new FormData();

          Object.keys(form).map((key: any) => {
            if (key != "id" && key != "owner_id" && key != "IMAGES") {
              if (
                key != "show_location" &&
                key != "lat" &&
                key != "lon" &&
                key != "bedrooms" &&
                key != "bathrooms" &&
                key != "beds" &&
                key != "travellers" &&
                key != "price" &&
                key != "REVIEWS" &&
                key != "PROMOTIONs" &&
                key != "DESCRIPTION_PROPERTY" &&
                key != "CHECKOUT" &&
                key != "CHECKIN" &&
                key != "SERVICES" &&
                key != "IMAGES" &&
                key != "PRICES" &&
                key != "FEES" &&
                form[key] !== ""
              ) {
                formdata.append(key, form[key]);
              }

              if (
                key == "show_location" ||
                key == "lat" ||
                key == "lon" ||
                key == "bedrooms" ||
                key == "bathrooms" ||
                key == "beds" ||
                key == "travellers" ||
                key == "price"
              ) {
                formdata.append(key, String(form[key]));
              }

              if (
                key == "PROMOTIONs" ||
                key == "CHECKOUT" ||
                key == "CHECKIN" ||
                key == "REVIEWS" ||
                key == "DESCRIPTION_PROPERTY" ||
                key == "CHECKOUT" ||
                key == "CHECKIN" ||
                key == "PRICES" ||
                key == "FEES"
              ) {
                if (form[key] !== null && form[key].length > 0) {
                  formdata.append(key, JSON.stringify(form[key]));
                }
              }

              if (
                key == "SERVICES"
              ) {
                if (form[key] !== null && form[key].length > 0) {

                  // Eliminar duplicados por nombre
                  const uniqueServices: any = Array.from(
                    new Map(form[key].map((item: any) => [item.name, item])).values()
                  );

                  formdata.append(key, JSON.stringify(uniqueServices));
                }
              }

              if (key == "CHECKOUT" || key == "CHECKIN") {
                if (form[key] !== null) {
                  formdata.append(key, JSON.stringify(form[key]));
                }
              }
            }
          });

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/properties/${property.id}`, requestOptions)
            .then(async () => {
              //const property = await response.json();

              CustomToast({
                status: 200,
                msg: "",
                title: "Alojamiento editado con exito",
              });

              navigate("/alquileres");
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
    }
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["alojamiento"],
    queryFn: async () => {

      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);

      return fetch(`${URL_API}/properties/${slug}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then(async (res) => {
        const response = await res.json();
        let coordinates: any = [];

        if (
          response.data.show_location &&
          JSON.parse(response.data.lat) &&
          JSON.parse(response.data.lon)
        ) {
          coordinates = [response.data.lat, response.data.lon];
        } else {
          coordinates = null;
        }

        setForm({
          ...form,
          id: response.data.id,
          owner_id: response.data.owner_id,
          type: response.data.type,
          space: response.data.space,
          address: response.data.address,
          country: response.data.country,
          province: response.data.province,
          city: response.data.city,
          postal_code: response.data.postal_code,
          show_location: JSON.parse(response.data.show_location),
          lat: response.data.lat,
          lon: response.data.lon,
          floor: response.data.floor,
          address_line_three: response.data.address_line_three,
          address_line_four: response.data.address_line_four,
          bedrooms: response.data.bedrooms,
          bathrooms: response.data.bathrooms,
          beds: response.data.beds,
          travellers: response.data.travellers,
          price: response.data.price,
          status: response.data.status,
          created_at: response.data.created_at,
          min_nights: response.data.min_nights,
          max_nights: response.data.max_nights,
          price_intelligent: response.data.price_intelligent,
          title: response.data.title,
          description: response.data.description,
          IMAGES: response.data.images,
          DESCRIPTION_PROPERTY: response.data.descriptions,
          FEES: response.data.fees,
          SERVICES: response.data.services,
          CHECKIN:
            response.data.checkin.length > 0 ? response.data.checkin[0] : null,
          CHECKOUT:
            response.data.checkout.length > 0
              ? response.data.checkout[0]
              : null,
          PRICES: response.data.prices,
          DATES: response.data.dates,
          coordinates: coordinates,
          //PROMOTIONs: response.data.checkout
          //REVIEWS
        });
        return response;
      });
    },
  });

  if (isPending) return (
    <div className="mx-auto w-full md:w-[80%] min-h-max py-7 md:px-3 px-0 bg-white rounded-lg shadow-sm border">
      <Skeleton className="h-10 w-64 mb-5 mx-3" />
      <div className="py-5 space-y-8">
        <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
          <div className="space-y-4">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-48 w-full rounded-lg" />
          </div>
          <div>
            <div className="grid grid-cols-2 gap-3">
              {[...Array(6)].map((_, i) => (
                <Skeleton key={i} className="h-48 rounded-lg" />
              ))}
            </div>
          </div>
        </div>
        <div className="px-5 space-y-4">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-32 w-full" />
        </div>
        <div className="px-5 space-y-4">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-20 w-full" />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-5">
          <div className="space-y-4">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-40 w-full" />
          </div>
          <div className="space-y-4">
            <Skeleton className="h-6 w-36" />
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-12 w-full" />
              <Skeleton className="h-12 w-full" />
            </div>
          </div>
        </div>
        <div className="px-5 space-y-4">
          <Skeleton className="h-6 w-28" />
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[...Array(8)].map((_, i) => (
              <Skeleton key={i} className="h-16 w-full" />
            ))}
          </div>
        </div>
        <div className="px-5 space-y-4">
          <Skeleton className="h-6 w-32" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-3">
              {[...Array(4)].map((_, i) => (
                <Skeleton key={i} className="h-10 w-full" />
              ))}
            </div>
          </div>
        </div>
        <div className="px-5 space-y-4">
          <Skeleton className="h-6 w-24" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <Skeleton className="h-48 w-full" />
            <div className="space-y-3">
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} className="h-8 w-full" />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="sticky w-full bg-white py-5" style={{ zIndex: 2, bottom: "0px" }}>
        <div className="flex justify-between px-5">
          <Skeleton className="h-12 w-24 rounded-full" />
          <Skeleton className="h-12 w-32 rounded-full" />
        </div>
      </div>
    </div>
  );

  if (error) {
    navigate("/404");
    return null;
  }

  if (!data || !data.data) {
    navigate("/404");
    return null;
  }

  const property = data.data;

  return (
    <div className="mx-auto w-full md:w-[80%]  min-h-max py-7 md:px-3 px- bg-white rounded-lg shadow-sm border">
      <span className="text-primary font-bold text-4xl block mb-5 px-3">
        Edita tu alojamiento
      </span>
      <div className="py-5">
        <Imagenes setForm={setForm} form={form} />
        <Descripciones setForm={setForm} form={form} />
        <Precio setForm={setForm} form={form} />
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <Tarifas setForm={setForm} form={form} />
          <DatosBasicos setForm={setForm} form={form} />
        </div>
        <Espacio setForm={setForm} form={form} />
        <Servicios setForm={setForm} form={form} />
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <Tipo setForm={setForm} form={form} />
          <Horarios setForm={setForm} form={form} />
        </div>
        <Direccion setForm={setForm} form={form} />
        <Bloqued setForm={setForm} form={form} />
        {/*<Descuentos setForm={setForm} form={form} />*/}
      </div>

      <div
        className="sticky w-full bg-white py-5"
        style={{ zIndex: 2, bottom: "0px" }}
      >
        <div className="flex justify-between">
          <button
            className={`cursor-pointer flex rounded-full btn btn-filled-2`}
            style={{ borderRadius: "20px" }}
            onClick={() => navigate("/alquileres")}
          >
            Cancelar
          </button>

          <button
            className={`cursor-pointer flex rounded-full btn btn-filled-2`}
            style={{ borderRadius: "20px" }}
            name="save"
            onClick={(event) => onClick(event, property)}
          >
            Actualizar datos
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditarAlquiler;
